var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgOutbound = function SvgOutbound(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13.049,
    height: 10.958,
    viewBox: "0 0 13.049 10.958",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 1183"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 69",
    transform: "translate(2.613 5.249)",
    style: {
      strokeLinecap: "round",
      fill: "none",
      stroke: "#5167fd"
    },
    d: "M0 0h9.935"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 20792",
    d: "m-18421.824-3850.792 2.414-2.415-2.414-2.414",
    transform: "translate(18431.959 3858.526)",
    style: {
      strokeLinejoin: "round",
      strokeLinecap: "round",
      fill: "none",
      stroke: "#5167fd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 20793",
    d: "M-18424.59-3852.131v-2.682h-7.082v9.958h7.082v-2.574",
    transform: "translate(18432.172 3855.313)",
    style: {
      strokeLinejoin: "round",
      fill: "none",
      stroke: "#5167fd"
    }
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgOutbound, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Outbound.50e982ad.svg";
export { ForwardRef as ReactComponent };